<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.permission_list }}
							</h6>
							<div class="element-box-tp">
								<ul>
									<li v-for="role in roles" class="mb-2">
										<strong>{{ role.d.name }}</strong>: {{ role.d.information }}
										<ul>
											<li v-for="sub in role.sub" >
												<strong>{{ sub.name }}</strong>: {{ sub.information }}
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact color-scheme-dark">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
    export default {
        name: "permissions",
	    data () {
            return {
                t: this.$root.t,
				isLoading: false,
	            roles: null
            }
	    },
	    mounted () {
          this.fetchRoles()
	    },
	    methods: {
            fetchRoles () {
                this.$http.get(api+'api/v1/roles')
                    .then(response => {

                    this.roles = response.body.result.roles;

                    }, response => {
                })
            }
	    }
    }
</script>

<style scoped>
	ul,li {
		list-style: none;
	}
	li {
		padding: 5px 10px
	}
</style>


// WEBPACK FOOTER //
// src/components/user/roles/permissions.vue